/**
 * Every number in this file was measured off the real corpus (spec appendix), not
 * assumed. Changing one without re-measuring is how the layout maths silently drifts
 * apart from the data.
 */

export const TOTAL_PAGES = 604
export const TOTAL_AYAT = 6236
export const TOTAL_SURAHS = 114
export const TOTAL_JUZ = 30

/**
 * 9,046 PHYSICAL lines: 602 pages × 15, plus pages 1 and 2 at 8 each (§3.7).
 *
 * Physical includes the 226 rows that are surah headers and standalone bismillahs.
 * Excluding them would need per-page line counts that meta.json does not carry and
 * that we deliberately do not ship — and they are rows the reader sees on the page
 * anyway. `navigation.ts` converts a line position to a fraction of the mushaf with it.
 */
export const TOTAL_LINES = 9046

// Layout (§7.6). --fit's fixed point is `widest === 0.995`; floating point never
// lands on it exactly, so without FIT_EPSILON every measurement writes a marginally
// different value and the page jitters forever (L4).
export const JUSTIFY_THRESHOLD = 0.84
export const PAGE_MARGIN = 26
export const MIN_PAGE_WIDTH = 380
export const PAGE_MAX_WIDTH = 860
export const FIT_EPSILON = 0.0005
export const MAX_MEASURE_PASSES = 8

// Font scale (§14.1)
export const FONT_SCALE_MIN = 60
export const FONT_SCALE_MAX = 170
export const FONT_SCALE_STEP = 5
export const FONT_SCALE_DEFAULT = 100

// Search (§9)
export const SEARCH_DEFAULT_LIMIT = 300
export const SEARCH_MIN_QUERY_LENGTH = 2

export const DAY_MS = 86_400_000

// UI timing (§8)
export const NOTE_DEBOUNCE_MS = 600

// Audio (§14.1)
export const PLAYBACK_RATES = [0.5, 0.75, 0.9, 1, 1.1, 1.25, 1.5] as const
export const DEFAULT_RECITER_ID = 'husary'
export const DEFAULT_PLAYBACK_RATE = 1

/**
 * Storage (§13).
 *
 * THESE NAMES ARE DELIBERATELY NOT THE ARABIC APP'S. Both apps are served from
 * `localhost` in development, which is ONE ORIGIN: a shared `localStorage` key or
 * IndexedDB name means each app rehydrates the other's settings and library, and
 * whichever loads second wins. The `en` suffix is the whole isolation mechanism —
 * it must also match the pre-paint theme read in `index.html`, which cannot import
 * from here.
 */
export const DB_NAME = 'mushaf-en'
/**
 * Version 1, not 2. The Arabic app is on 2 because it migrated a v1 database in the
 * field; this database name has never existed before, so there is no history to carry
 * and the `srs`/`programs` stores it used to create are not wanted here.
 */
export const DB_VERSION = 1
export const BACKUP_VERSION = 1
export const LS_LAST_PAGE = 'mushaf-en.lastPage'
export const LS_SETTINGS = 'mushaf-en.settings'
export const SETTINGS_VERSION = 1

/** Where the corpus is served from, relative to the site root. */
export const CORPUS_BASE = '/corpus'
